<template>
  <family-page-wrapper>
    <p style="font-size: 18px; margin-bottom: 20px">
      Choose a location below to add a custom location to your account or to edit an existing location on your account.
    </p>
    <main-custom-locations />
    <custom-addresses />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const MainCustomLocations = defineAsyncComponent(() => import('@/components/UIComponents/CustomLocations/CustomLocations.vue') as any);

const CustomAddresses = defineAsyncComponent(() => import('@/components/UIComponents/CustomLocations/CustomAddresses.vue') as any);
</script>
